import { Icon } from "@xinghai/ui";
import { useAuth } from "./useAuth";
import { WORK_AGREEMENT_TITLE } from "./workAgreementText";

/**
 * 「已签署《标注成果授权协议》v1（日期）」 for staff accounts.
 * Renders nothing until the server reports a signature, so it is safe to drop
 * into 我的 / 我的进度 for any role.
 */
export function WorkAgreementStatus({ className }: { className?: string }) {
  const { me } = useAuth();
  const wa = me?.work_agreement;
  if (!wa?.version) return null;
  const when = wa.accepted_at ? `（${wa.accepted_at}）` : "";
  return (
    <p className={className ?? "gz-caption"}>
      <Icon id="ui-check-circle" size={16} /> 已签署《{WORK_AGREEMENT_TITLE}》{wa.version}
      {when}
    </p>
  );
}
